var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-captcha",attrs:{"data-sitekey":"ysc1_gvEbLG4PR2Di2wp2Q1K61QBjH9taWnrmEtBLSDg1e0d12fba","data-callback":"getToken"}})
}
var staticRenderFns = []

export { render, staticRenderFns }